import { Struct, array, assign, object } from "superstruct";

import OffsetPaginationMetaSchema from "./OffsetPaginationSchema";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
const assignOffsetPagination = <T extends Struct<any>>(schema: T) => {
    return assign(
        OffsetPaginationMetaSchema,
        object({
            items: array(schema),
        })
    );
};

export default assignOffsetPagination;
